import type { Face2d } from "."
import type { DrawFacesProcedure } from "./drawFaces"
import { traceMeshes } from "./drawFaces"
import type { ExtractMeshOptions } from "./extract"
import { extractMeshFromStore } from "./extract"
import { findFlaws } from "./findFlaws"

export type AddFacesOptions = ExtractMeshOptions & {
  resetResults: () => void
  addFace: (id: string, face: Face2d) => void
  setValid: () => void
}

export const loadFacesIntoStore = ({
  nodeIds,
  edgeIds,
  getNode,
  getEdge,
  resetResults,
  addFace,
  setValid,
}: AddFacesOptions): DrawFacesProcedure => {
  resetResults()

  const mesh = extractMeshFromStore({ nodeIds, edgeIds, getNode, getEdge })

  const flaws = findFlaws(mesh)

  const meshIsValid = !flaws.NODE.length && !flaws.EDGE.length

  if (meshIsValid) {
    setValid()
  }
  const { faces, procedure } = traceMeshes(mesh.nodes, mesh.edges)
  for (const [faceId, face] of faces) {
    addFace(faceId, face)
  }

  return procedure
}
